import React, {useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { img } from '../../../config';
import { drawP, cleanArr } from './functions';

const useStyles = makeStyles(theme => ({
  complete: {
    position: 'relative',
    '& h3': {
      textAlign: 'center',
      color: theme.palette.primary.main,
    },
  },
  imgCont: {
    textAlign: 'center',
    '& img': {
      width: 120,
    },
  },
  words: {
    color: theme.palette.secondary.main,
  },
  inputs: {
    '& input': {
      border: '1px solid #666',
      borderRadius: 3,
      background: '#eee',
      outline: 'none !important',
      padding: '3px 5px',
      textAlign: 'center',
      margin: ' 0 5px',
    },
    '& p': {
      lineHeight: 2,
      margin: '0.2em 0',
    },
  },
  closeQuiz: {
    position: 'absolute',
    top: -20,
    right: -20,
    color: '#999',
    transition: 'color 0.3s',
    cursor: 'pointer',
    '&:hover': {
      color: '#333',
    },
  },
  quizAction: {
    textAlign: 'center',
    marginTop: 20,
    '& button': {
      margin: '0 1px',
    },
    '& > div': {
      display: 'inline-block',
      padding: '0.25em 1em',
      color: '#a1008f',
      verticalAlign: 'middle',
      margin: '0 1px',
      borderRadius: 3,
    },
  },
  '@media(max-width: 850px)': {

  }
}));

let inputNo = 0;
let timeout1 = 0;
let timeout2 = 0;
let savedAnswers = false;
let em = false;

function Complete(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const [ previews, setPreviews ] = useState(0);
  const exercise = props.data[props.state.idx];
  const current = exercise.data[no];
  const len = exercise.data.length;
  const [ testFinished, setTestFinished ] = useState(false);
  const [ preview, setPreview ] = useState(false);
  const { action } = props;
  const refs = [];

  useEffect(() => {
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFirstFocus();
    // eslint-disable-next-line
  }, [no]);

  for (var i = 0; i < 20; i++) {
    // eslint-disable-next-line
    refs[i] = useRef();
  }

  const getIElement = (str, idx, idx2) => {
    const key = 's' + idx + '-' + idx2;

    const drawInput = (width, smallFont = false) => {
      const ref = refs[inputNo];
      inputNo++;
      if (preview && current.answers[inputNo - 1].indexOf(savedAnswers[inputNo - 1]) === -1) {
        const correctAnswer = current.answers[inputNo - 1];
        refs[inputNo - 1].current.value = correctAnswer;
        return <input 
          key={key} 
          ref={ref} 
          spellCheck="false"
          defaultValue={current.answers[inputNo - 1]}
          style={{color: 'green', width, fontSize: smallFont ? 12 : 14 }}
          onKeyDown={handleKeyDown}
        />;
      } else {
        return <input 
          key={key} 
          ref={ref} 
          spellCheck="false"
          onKeyDown={handleKeyDown}
          style={{width, fontSize: smallFont ? 12 : 14 }}
        />;
      }
    }

    switch(str) {
      case 'em':
        em = true;
        break;
      case '/em':
        em = false;
        break;
      case 'input':
        return drawInput(120);
      case 'mediumInput':
        return drawInput(200);
      case 'longInput':
        return drawInput(300, true);
      case 'shortInput':
        return drawInput(50);
      default:
        if (em) {
          return <span key={key} style={{color: '#a1008f'}}>{str}</span>
        } else {
          return <React.Fragment key={key}>{str}</React.Fragment>
        }
        
    }
  }

  const drawInputs = (p, idx) => {
    const arr = cleanArr(p.split(/\[|\]/));
    const key = 'p' + idx;
    em = false;
    return (
      <p key={key}>
        {arr.map((part, idx2) => getIElement(part, idx, idx2))}
      </p>
    );
  }

  const setFirstFocus = () => {
    refs[0] && refs[0].current && refs[0].current.focus();
  }
  const handleKeyDown = (ev) => {
    action();
    if (ev.key === 'Enter') checkAnswers();
  }

  const checkAnswer = (i) => {
    const val = refs[i].current.value.trim();
    return current.answers[i].indexOf(val) !== -1
  }

  const checkAnswers = () => {
    action();
    let failed = 0;
    for (let i = 0; i < inputNo; i++) {
      if (!checkAnswer(i)) {
        failed++;
        refs[i].current.value = '';
      }
    }
    if (failed) {
      props.media.failure();
    } else {
      if (no === len -1) {
        props.media.applause();
        setTestFinished(true);
        props.completePart();
      } else {
        props.media.success();
        cleanInputs();
        next();
      }

    }
  }

  const cleanInputs = () => {
    for ( let i = 0; i < inputNo; i++ ) {
      refs[i].current.value = '';
    }
  }

  const showPreview = () => {
    action();
    savedAnswers = [];
    for (let i = 0; i < inputNo; i++) {
      savedAnswers[i] = refs[i].current.value.trim();
    }

    setPreview(true);
    setPreviews(previews + 1);
    timeout1 = setTimeout(() => {
      for (i = 0; i < inputNo; i++) {
        refs[i].current.value = savedAnswers[i];
      }
      savedAnswers = false;
      setPreview(false);
    }, 1500);
  }

  const next = () => {
    action();
    if (no < len - 1) {
      setNo(no + 1);
      setPreviews(0);
    }
  }

  const pagination = (no + 1) + '/' + len;
  inputNo = 0;

  return (
    <div className={classes.complete}>
      <IconButton className={classes.closeQuiz} onClick={props.close}>
        <CloseIcon />
      </IconButton>
      <div className={classes.imgCont}>
        <img src={img('brain-lens.jpg')} alt='' />
        <h3>{exercise.title}</h3>
        <div className={classes.words}>
          {current.intro.map(drawP)}
        </div>
        <div className={classes.inputs}>
          {current.text.map(drawInputs)}
        </div>
      </div>
      <div className={classes.quizAction}>
        <p className={classes.qPagination}>{pagination}</p>
        {!testFinished && <Button variant="outlined" color="secondary" onClick={checkAnswers} disabled={preview}>Sprawdź</Button>}
        {!testFinished && <Button variant="outlined" color="secondary" onClick={showPreview} disabled={previews > 2}><EyeIcon /></Button>}
        {testFinished && <Button variant="outlined" color="secondary" onClick={props.close}>Powrót</Button>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Complete);